import { createComponent } from '@carvana/merch-components';
import { EvGuideSection } from '../../styles';

export const Section = createComponent(EvGuideSection, {
  className: 'flex flex-col gap-2xl !pt-0 sm:gap-3xl'
});

export const ListItem = createComponent('li', {
  className:
    'relative ml-3xl break-inside-avoid-column text-grey-5 tl-body-m before:list-none'
});
